module.exports = __webpack_public_path__ + "static/banner_action_mobile-f7576a7a5a05a8a25cff5a2628f4b854.png";